export enum OrderStatusId {
  all = 0,
  draft = 1,
  inProgress = 2,
  needsApproval = 3,
  finished = 5,
  new = 6,
  messagedLab = 7,
  cancelled = 8,
  processing = 9,
  printing = 10,
  onHold = 11,
}
